import { render } from "./CountryListPage.vue?vue&type=template&id=1399cfb4&scoped=true"
import script from "./CountryListPage.vue?vue&type=script&lang=js"
export * from "./CountryListPage.vue?vue&type=script&lang=js"

import "./CountryListPage.vue?vue&type=style&index=0&id=1399cfb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1399cfb4"

export default script